import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: 24,
    fontSize: 16
  }
}))

const PatientsListRestricted = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return <div className={classes.root}>{t('pages.copilotControl.mainPage.patientsListRestricted')}</div>
}

export default PatientsListRestricted
